import { type T, Translate } from '../../i18n/index';
import { m } from '../../mithril';
import type { MithrilVNode } from '../../mithril';
import { MaterialIcon } from '../icon/icons';
import { Icon } from '../icon/index';
import { addStyles } from '../theme';

export interface FABButtonCtx {
	disabled?: boolean;
	title?: T;
	onclick?: (a?: Event) => void;
}

export const CSS = {
	container: 'c-FAB-Button',
	MDL: {
		container: 'mdl-button mdl-button--accent mdl-button--fab',
	},
};

addStyles({
	[CSS.container]: {
		position: 'fixed',
		bottom: '80px',
		right: '8%',
		'z-index': 5,
	},
});

export const FabButton = {
	view(ctx: FABButtonCtx = {}): MithrilVNode {
		return m(
			'button',
			{
				className: `${CSS.container} ${CSS.MDL.container}`,
				disabled: ctx.disabled,
				title: Translate(ctx.title),
				onclick: ctx.onclick,
				'data-testid': 'fab-add',
			},
			Icon.view(MaterialIcon.ADD)
		);
	},
};
